const phoneNumberRegex = /^((\d{10})|([1-9]\d{2}-\d{3}-\d{4}))$/i;

export { phoneNumberRegex };
